import type { Observable, OperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

type Extends<T, U> = T extends U ? T : never;

export function filterInstanceOf<T, U extends Function>(type: U): OperatorFunction<T, NonNullable<Extends<T, U>>> {
	return (source$: Observable<T | null | undefined>) => <Observable<NonNullable<Extends<T, U>>>> <unknown> source$
		.pipe(filter(v => !!v && (v instanceof type)));
}
